export enum SettingTypeEnum {
  TITLE = 'title',
  THEME = 'theme',
  SIDE_THEME = 'sideTheme',
  SHOW_SETTINGS = 'showSettings',
  TOP_NAV = 'topNav',
  TAGS_VIEW = 'tagsView',
  FIXED_HEADER = 'fixedHeader',
  SIDEBAR_LOGO = 'sidebarLogo',
  DYNAMIC_TITLE = 'dynamicTitle',
  ANIMATION_ENABLE = 'animationEnable',
  LAYOUT = 'layout',
  DARK = 'dark',

  LAYOUT_SETTING = 'layout-setting'
}
